<template>
  <div class="note">
    <div class="row">
      <div class="form-group col-sm-12 col-lg-5 text-left">
        <label class="control-label">{{ $t("remark") }}</label>
        <DxTextArea
          v-model="localData.notes"
          placeholder=""
          :height="100"
          :rows="4"
          :cols="50"
          :maxLength="250"
          :showClearButton="true"
        ></DxTextArea>
      </div>
    </div>
  </div>
</template>

<script>
import DxTextArea from "devextreme-vue/text-area";
export default {
  name: "note",
  props: {
    formData: {
      type: Object,
      required: true,
    },
     number: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData }, // Create a local copy of formData
    };
  },
  computed: {},
  components: {
    DxTextArea,
  },
  methods: {
    validate() {
      return {
        error: false,
        message: "",
      };
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        //console.log("updateData step 5 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
  },
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-form-data", newData, this.number); // Emit updated data to parent
      },
    },
  },
};
</script>

<style scoped>
.note {
  height: 100%;
  width: 100%;
}
</style>
